export default __webpack_public_path__ + "static/media/blender.1d750a2a.svg";